<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
   import jsPDF from "jspdf";
   import autoTable from "jspdf-autotable";

   export default {
      page: {
         title: "Invoice Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Invoice Report",
            items: [
               {
                  text: "Invoice Report",
                  active: true,
               },                   
            ],

            sales: [],            
            
            pagination: {},
            invoices: [],
            doctors: [],
            all_consultations: [],
            doctor_id: "",
            from_date: current_date,
            to_date: current_date,
            keyword: "",
            listing_length: 10,
            status: '',
            type: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         // this.fetchDoctors();
         this.fetchInvoices();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         clearForm() {
               this.errors = {};  
         },
         // fetchDoctors() {  
         //    let url = "api/admin/consultations/getdoctors?keyword=" + '';         
         //    this.getToken();
         //    this.$axios
         //       .get(url, { headers: { Authorization: "Bearer " + this.token } })
         //       .then((res) => {
         //          var responseData = res.data.data;
         //          console.log(responseData);
         //          this.doctors = responseData.doctors;
         //       })
         //       .catch((err) => console.log(err));
         // },

         fetchInvoices(page_url = null) {

            this.getToken();
            let url = "api/admin/invoiceReport?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&type=" + this.type ;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.invoices = responseData.invoices.data;
                  // this.all_consultations = responseData.all_consultations;

                  this.pagination = responseData.invoices.links;
                  this.from = responseData.invoices.from;
                  this.to = responseData.invoices.to;
                  this.total = responseData.invoices.total;
               this.clearForm();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           this.errors = error.response.data.message;
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         downloadConsultationsPdf() {
            let url = "api/admin/consultation_report_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&status=" + this.status + "&type=" + this.type;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "consultation_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },

       downloadInvoicePdfFromClient() {
            if (!this.invoices.length) {
               this.$swal("", "No data available to download", "info");
               return;
            }

            const doc = new jsPDF({
               orientation: 'landscape',
               unit: 'mm',
               format: 'a4'
            });

            doc.setFontSize(14);
            doc.text("Invoice Report", 14, 15);

            const headers = [[
               "Sl No",
               "Date",
               "Invoice Number",
               "Customer Name",
               "Place",
               "Description",
               "SAC Code",
               "Taxable Value",
               "Tax Rate",
               "CGST",
               "SGST",
               "IGST",
               "Invoice Value",
               "Place of Supply"
            ]]; // Excludes "Options", as buttons/links don't apply in PDF

            const rows = this.invoices.map((invoice) => {
               const sl_no = invoice.sl_no || '';
               const date = invoice.date || '';
               const invoice_no = invoice.invoice_no || '';
               const customer = invoice.customer_name || '';
               const place = invoice.state || '';
               const description = invoice.type === 1
                  ? (invoice.booking?.consultation_type === 1 ? "Consultation Fee" : "Convenience Fee")
                  : "Pharmacy";
               const sac_code = invoice.sac_code || '';
               const taxable_value = invoice.taxable_value || '0.00';
               const tax_rate = invoice.tax_rate || '0';
               const cgst = invoice.cgst || '0.00';
               const sgst = invoice.sgst || '0.00';
               const igst = invoice.igst || '0.00';
               const total = invoice.total || '0.00';
               const place_supply = invoice.place || '';

               return [
                  sl_no,
                  date,
                  invoice_no,
                  customer,
                  place,
                  description,
                  sac_code,
                  taxable_value,
                  tax_rate,
                  cgst,
                  sgst,
                  igst,
                  total,
                  place_supply
               ];
            });

            autoTable(doc, {
               startY: 20,
               head: headers,
               body: rows,
               styles: {
                  fontSize: 8,
                  cellPadding: 2
               },
               headStyles: {
                  fillColor: [41, 128, 185],
                  textColor: 255
               },
               columnStyles: {
                  0: { cellWidth: 10 },   // Sl No
                  1: { cellWidth: 20 },   // Date
                  2: { cellWidth: 25 },   // Invoice Number
                  3: { cellWidth: 30 },   // Customer Name
                  4: { cellWidth: 20 },   // Place
                  5: { cellWidth: 20 },   // Description
                  6: { cellWidth: 20 },   // SAC Code
                  7: { cellWidth: 20 },   // Taxable Value
                  8: { cellWidth: 15 },   // Tax Rate
                  9: { cellWidth: 15 },   // CGST
                  10: { cellWidth: 15 },   // SGST
                  11: { cellWidth: 15 },  // IGST
                  12: { cellWidth: 25 },  // Invoice Value
                  13: { cellWidth: 25 }   // Place of Supply
               },
               didDrawPage: function () {
                  doc.setFontSize(10);
                  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, doc.internal.pageSize.height - 10);
               }
            });

            doc.save("Invoice_Report.pdf");
         },

         downloadInvoiceExcel() {
            let url = "api/admin/invoiceReportExcel?from_date=" + this.from_date + "&to_date=" + this.to_date  + "&type=" + this.type;     
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" // Specify blob response type
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "invoice_report.xlsx";
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },


         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },  

         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-3">
                        <label>From Date <span class="text-danger">*</span></label>
                        <!-- <b-form-input type="date" ></b-form-input> -->
                        <input type="date" v-model="from_date" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }">
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     <div class="form-group col-lg-3">
                        <label>To Date <span class="text-danger">*</span></label>
                        <!-- <b-form-input type="date"></b-form-input> -->
                        <input type="date" v-model="to_date" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }">
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     
                     <div class="form-group col-lg-3">
                        <label>Type</label>
                       <select class="form-control" v-model="type" >
                                 <option value="">All</option>
                                 <option value="1">Doctor Booking</option>
                                 <option value="3">Pharmacy Booking</option>
                              </select>
                     </div>
                  </div>
                  <!----- filters area ends---->

                  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button" @click="fetchInvoices()">View</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadInvoicePdfFromClient()">Download PDF</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadInvoiceExcel()">Download Excel</button>                     </div>
                  </div>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchInvoices()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchInvoices()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                              <tr>
                              <th width="5%">Sl No</th> 
                              <th width="15%">Date</th> 
                              <th width="15%">Invoice Number</th> 
                              <th width="15%">Customer Name</th>
                              <th width="15%">Place</th>              
                              <th width="15%">Description</th> 
                              <th width="15%">SAC Code</th>              
                              <th width="15%">Taxable Value</th>
                              <th width="15%">Tax Rate</th>   
                              <th width="5%">CGST</th>
                              <th width="20%">SGST</th>
                              <th width="20%">IGST</th>
                              <th width="20%">Invoice Value</th>  
                              <th width="15%">Place of Supply</th>
                              <th width="20%">Options</th>
                           </tr>
                          
                        </thead>
                        <tbody v-if="Boolean(invoices.length)">
                           <tr v-for="invoice in invoices" :key="invoice.id">
                              <td>{{invoice.sl_no}}</td>
                              <td>{{invoice.date}}</td>
                              <td>{{invoice.invoice_no}}</td> 
                              <td>{{invoice.customer_name}}</td> 
                              <td>{{invoice.state}}</td> 
                              <td>
                                 <span v-if="invoice.type ==1">
                                    <span v-if="invoice.booking.consultation_type ==1">Consultation Fee</span>
                                    <span v-else>Convenience Fee</span>
                                 </span>
                                 <span v-else>Pharmacy</span>
                              </td>
                              <td>{{invoice.sac_code}}</td>
                              <td>{{invoice.taxable_value}}</td>
                              <td>{{invoice.tax_rate}}</td> 
                              <td>{{invoice.cgst}}</td> 
                              <td>{{invoice.sgst}}</td> 
                              <td>{{invoice.igst}}</td> 
                              <td>{{invoice.total}}</td> 
                              <td>{{invoice.place}}</td>
                              <td>
                                 <router-link v-if="invoice.type ==1" :to="{ name: 'consultations.details', params:{ id:invoice.booking_id } }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                                 <router-link v-if="invoice.type ==3" :to="{ name: 'pharmacy.orders.details', params: { id: invoice.pharmacy_order_id } }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                              </td> 
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No invoices found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(invoices.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchInvoices(page.url + '&limit='+ listing_length + '&from_date='+ from_date + '&to_date=' + to_date + '&keyword=' + keyword  + '&type=' + type )">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
